"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentLegacySession = void 0;

var js_base64_1 = require("js-base64");

var __1 = require("../..");

var interface_adapter_1 = require("../../Interfaces/interface.adapter");

var config_legacy_api_1 = require("../Configs/config.legacy.api");

var PaymentLegacyEncryptor_1 = require("../Encryption/PaymentLegacyEncryptor");

var PaymentLegacyCommunicator_1 = require("./PaymentLegacyCommunicator");

var LegacyPaymentMethod;

(function (LegacyPaymentMethod) {
  LegacyPaymentMethod["creditCard"] = "CC";
  LegacyPaymentMethod["ACH"] = "DD";
  LegacyPaymentMethod["eCheck"] = "ECHECK";
  LegacyPaymentMethod["ePaperToken"] = "CC";
})(LegacyPaymentMethod || (LegacyPaymentMethod = {}));

var PaymentLegacySession =
/** @class */
function () {
  function PaymentLegacySession(env, sessionId, sessionData, billingContact) {
    this.env = env;
    this.securityToken = PaymentLegacySession.formatSecurityToken(sessionId);
    this.version = this.securityToken.charAt(0) === "S" ? 1 : 2;
    this.sessionData = sessionData;
    this.sessionData.appName = PaymentLegacySession.formatAppName(this.sessionData.appName);
    this.sessionData.currency = PaymentLegacySession.formatCurrency(this.sessionData.currency);

    if (this.version === 1) {
      // Validate encryption key
      PaymentLegacySession.isValidRSAPublicKey(this.sessionData.encryptionKey);
    }

    this.billingContact = billingContact;
    this.paymentCommunicator = new PaymentLegacyCommunicator_1.PaymentLegacyCommunicator(env);
  }

  PaymentLegacySession.formatSecurityToken = function (securityToken) {
    PaymentLegacySession.isValidSecurityToken(securityToken);
    return securityToken;
  };

  PaymentLegacySession.isValidSecurityToken = function (securityToken) {
    if (!/^[SV][a-zA-Z0-9]{32}$/.test(securityToken)) {
      throw new __1.PaymentValidationError("Security token contains illegal characters or has illegal format", __1.PaymentErrorShortCodes.invalid_session);
    }

    return true;
  };

  PaymentLegacySession.formatAppName = function (appName) {
    PaymentLegacySession.isValidAppName(appName);
    return appName;
  };

  PaymentLegacySession.isValidAppName = function (appName) {
    if (appName.length === 0) {
      throw new __1.PaymentValidationError("Application Name contains illegal characters or has illegal format", __1.PaymentErrorShortCodes.invalid_app_name);
    }

    return true;
  };

  PaymentLegacySession.formatCurrency = function (currency) {
    PaymentLegacySession.isValidCurrency(currency);
    return currency;
  };

  PaymentLegacySession.isValidCurrency = function (currency) {
    if (!/^[a-zA-Z]{1,3}$/.test(currency)) {
      throw new __1.PaymentValidationError("Currency contains illegal characters or has illegal format", __1.PaymentErrorShortCodes.invalid_currency);
    }

    return true;
  };

  PaymentLegacySession.isValidRSAPublicKey = function (publicKey) {
    if (!/^[a-zA-Z0-9]{1,512}$/.test(publicKey)) {
      throw new __1.PaymentValidationError("Encryption Key contains illegal characters or has illegal format", __1.PaymentErrorShortCodes.invalid_encryption_key);
    }

    return true;
  };

  PaymentLegacySession.isValidVendorSessionToken = function (sessionToken) {
    if (sessionToken.vendorName !== interface_adapter_1.PaymentVendors.ingenico || !sessionToken.token || !sessionToken.publicKey) {
      throw new __1.PaymentValidationError("Encryption Key has illegal format", __1.PaymentErrorShortCodes.invalid_encryption_key);
    }

    return true;
  };

  PaymentLegacySession.prototype.processLegacyCreditCardPayment = function (creditCard) {
    return __awaiter(this, void 0, void 0, function () {
      var legacyEncryptor, encryptedCard, encodedSessionToken, encodedToken, decodedToken, sessionToken, billingMethodParams, urlParams, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            legacyEncryptor = new PaymentLegacyEncryptor_1.PaymentLegacyEncryptor();
            if (!(this.version === 2)) return [3
            /*break*/
            , 2];
            encodedSessionToken = void 0;

            try {
              encodedToken = JSON.parse(this.sessionData.encryptionKey);
              encodedSessionToken = encodedToken.sessionToken;
              decodedToken = js_base64_1.Base64.decode(encodedSessionToken);
              sessionToken = JSON.parse(decodedToken);
              PaymentLegacySession.isValidVendorSessionToken(sessionToken);
            } catch (e) {
              throw new __1.PaymentValidationError("Encryption Key has illegal format", __1.PaymentErrorShortCodes.invalid_encryption_key, {
                cause: {
                  message: e.message,
                  details: JSON.stringify(e)
                }
              });
            }

            return [4
            /*yield*/
            , legacyEncryptor.ingenicoEncryptCreditCardInfo(encodedSessionToken, creditCard, this.billingContact)];

          case 1:
            encryptedCard = _a.sent();
            return [3
            /*break*/
            , 4];

          case 2:
            return [4
            /*yield*/
            , legacyEncryptor.rsaEncryptCreditCardInfo(this.sessionData.encryptionKey, creditCard)];

          case 3:
            encryptedCard = _a.sent();
            _a.label = 4;

          case 4:
            billingMethodParams = {
              exp_month: creditCard.expiration.month,
              exp_year: creditCard.expiration.year
            };
            return [4
            /*yield*/
            , this.paymentCommunicator.getUrlParams(this.securityToken, LegacyPaymentMethod.creditCard, encryptedCard, this.sessionData.appName, this.billingContact, billingMethodParams)];

          case 5:
            urlParams = _a.sent();
            return [4
            /*yield*/
            , this.paymentCommunicator.processLegacyPayment(this.version, urlParams)];

          case 6:
            response = _a.sent();
            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  PaymentLegacySession.prototype.processLegacyACHPayment = function (achInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var legacyEncryptor, encryptedACHData, urlParams, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.version === 2) {
              this.version = 1;
              this.sessionData.encryptionKey = config_legacy_api_1.LegacyConfig.getDefaultRSAPublicKey(this.env);
            }

            legacyEncryptor = new PaymentLegacyEncryptor_1.PaymentLegacyEncryptor();
            return [4
            /*yield*/
            , legacyEncryptor.rsaEncryptACHInfo(this.sessionData.encryptionKey, achInfo)];

          case 1:
            encryptedACHData = _a.sent();
            return [4
            /*yield*/
            , this.paymentCommunicator.getUrlParams(this.securityToken, LegacyPaymentMethod.ACH, encryptedACHData, this.sessionData.appName, this.billingContact)];

          case 2:
            urlParams = _a.sent();
            return [4
            /*yield*/
            , this.paymentCommunicator.processLegacyPayment(this.version, urlParams)];

          case 3:
            response = _a.sent();
            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  PaymentLegacySession.prototype.processLegacyECheckPayment = function (eCheckInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var legacyEncryptor, encryptedECheckData, urlParams, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.version === 2) {
              this.version = 1;
              this.sessionData.encryptionKey = config_legacy_api_1.LegacyConfig.getDefaultRSAPublicKey(this.env);
            }

            legacyEncryptor = new PaymentLegacyEncryptor_1.PaymentLegacyEncryptor();
            return [4
            /*yield*/
            , legacyEncryptor.rsaEncryptECheckInfo(this.sessionData.encryptionKey, eCheckInfo)];

          case 1:
            encryptedECheckData = _a.sent();
            return [4
            /*yield*/
            , this.paymentCommunicator.getUrlParams(this.securityToken, LegacyPaymentMethod.eCheck, encryptedECheckData, this.sessionData.appName, this.billingContact)];

          case 2:
            urlParams = _a.sent();
            return [4
            /*yield*/
            , this.paymentCommunicator.processLegacyPayment(this.version, urlParams)];

          case 3:
            response = _a.sent();
            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  PaymentLegacySession.prototype.processLegacyEPaperTokenPayment = function (ePaperTokenInfo) {
    return __awaiter(this, void 0, void 0, function () {
      var legacyEncryptor, encryptedEPaperTokenData, billingMethodParams, urlParams, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (this.version === 2) {
              this.version = 1;
              this.sessionData.encryptionKey = config_legacy_api_1.LegacyConfig.getDefaultRSAPublicKey(this.env);
            }

            legacyEncryptor = new PaymentLegacyEncryptor_1.PaymentLegacyEncryptor();
            return [4
            /*yield*/
            , legacyEncryptor.rsaEncryptEPaperTokenInfo(this.sessionData.encryptionKey, ePaperTokenInfo)];

          case 1:
            encryptedEPaperTokenData = _a.sent();
            billingMethodParams = {
              exp_month: ePaperTokenInfo.expiration.month,
              exp_year: ePaperTokenInfo.expiration.year
            };
            return [4
            /*yield*/
            , this.paymentCommunicator.getUrlParams(this.securityToken, LegacyPaymentMethod.ePaperToken, encryptedEPaperTokenData, this.sessionData.appName, this.billingContact, billingMethodParams)];

          case 2:
            urlParams = _a.sent();
            return [4
            /*yield*/
            , this.paymentCommunicator.processLegacyPayment(this.version, urlParams)];

          case 3:
            response = _a.sent();
            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  return PaymentLegacySession;
}();

exports.PaymentLegacySession = PaymentLegacySession;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Legacy/Session/PaymentLegacySession.js